module.exports = __webpack_public_path__ + "img/contacts-no-selection.1916d805.svg";